import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
 
@Component({
  selector: 'capital-demand-leader-table',
  templateUrl: './capital-demand-leader-table.component.html',
  styleUrls: ['./capital-demand-leader-table.component.css'],
  standalone: false,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
    ]),
  ],
})
export class CapitalDemandTableComponent implements OnChanges {
  displayedColumns: string[] = [];
  flattenedData : any;
  @Input() COLUMNS: any[];
  leaderDataTable: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() leaderData: any[];
 
  activeLeader: any = {};
  showleaderOrOwner: string = 'leader'; // This was used in your template
 
  ngOnChanges() {
    if (this.COLUMNS) {
      this.displayedColumns = this.COLUMNS.map((column) => column.key);
    }
    if (this.leaderData && this.leaderData.length > 0) {
      //const hierarchicalData = this.transformDataToHierarchy(this.leaderData);
      this.leaderDataTable.data = this.leaderData;
      this.flattenedData = [];
      this.leaderData.forEach(item => {
        if (item.L1) this.flattenedData.push({ ...item.L1 });
        if (item.L2) this.flattenedData.push({ ...item.L2 });
        if (item.L3) this.flattenedData.push({ ...item.L3 });
      });

      console.log(this.leaderData);
    } else {
      this.leaderDataTable.data = [];
    }
  }
 
 
  private setupDataSources(leaders: any[]): void {
    for (const leader of leaders) {
      if (leader.child && leader.child.length > 0) {
        leader.childDataSource = new MatTableDataSource(leader.child);
        this.setupDataSources(leader.child);
      }
    }
  }
 
  expandCollapseLeader(action: string, leader: any): void {
    leader.expand = action === 'expand' ? 1 : 0;
  }
 
  appsClicked(level: any): void {
    if (this.activeLeader && this.activeLeader.msid) {
      this.activeLeader.active = 0;
    }
    level.active = 1;
    this.activeLeader = level;
    level.expand = 0;
    this.leaderDataTable.data = [level];
  }
}